<template>
    <div class="root">
      <div class="module">
        <div class="module-title">
          <img src="@/assets/dashboard/u427.png">
          当前
        </div>
  
        <div id="app">
      <el-card class="introduction-card">
        <div class="image-container">
          <img src="@/images/zuke.webp" alt="个人图片">
        </div>
        <div class="text-container">
          <h2>个人介绍</h2>
          <button @click="edit">修改</button>
          <p style="padding: 10px;margin: 10px;" :v-model="comment">
           {{comment}}
          </p>
          <el-dialog v-model="dialogVisible" title="修改个人简介" width="30%">
        <el-form label-position="top">
          <el-form-item label="个人简介">
            <textarea v-model="newIntroduction" style="width: 400px; height: 320px;"></textarea>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="updateIntroduction">确定</el-button>
        </span>
      </el-dialog>
        </div>
      </el-card>
    </div>
  
  
  
  
      </div>
      <div class="module">
        <div class="module-title">
          <img src="@/assets/dashboard/u427.png">
          快捷导航
        </div>
        <div class="module-content">
          <div class="module-content-item2" @click="handleClick('/packone')">商家个人信息</div>
          <div class="module-content-item2" @click="handleClick('/packfore')">个人餐厅信息</div>
          <!-- <div class="module-content-item2" @click="handleClick('/dataview/dataviewInventory')">数据看板</div> -->
        </div>
      </div>
      <div class="module module-descriptions">
        <div class="module-title">
          <img src="@/assets/dashboard/u427.png">
          服务器信息
        </div>
        <div class="descriptions">
          <div class="descriptions-row">
            <div>服务器系统：</div>
            <div>Linux</div>
            <div>网站域名/IP：</div>
            <div>www.xxxx.com/127.0.0.1</div>
          </div>
          <div class="descriptions-row">
            <div>服务器系统：</div>
            <div>Linux</div>
            <div>网站域名/IP：</div>
            <div>www.xxxx.com/127.0.0.1</div>
          </div>
          <div class="descriptions-row">
            <div>服务器系统：</div>
            <div>Linux</div>
            <div>网站域名/IP：</div>
            <div>www.xxxx.com/127.0.0.1</div>
          </div>
          <div class="descriptions-row">
            <div>服务器系统：</div>
            <div>Linux</div>
            <div>网站域名/IP：</div>
            <div>www.xxxx.com/127.0.0.1</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'dashboard',
    data() {
      return {
        comment:'欢迎来到商户后台管理系统'
      ,
      dialogVisible:false,
      newIntroduction:''
    }
    },
    methods: {
      handleClick(path) {
        this.$router.push({ path })
      },
      edit(){
  this.dialogVisible=!this.dialogVisible
      },
  
      updateIntroduction(){
        this.comment=this.newIntroduction
        this.dialogVisible=!this.dialogVisible
        
      }
    },
  }
  
  </script>
  
  <style lang="less" scoped>
  .root {
    padding: 16px;
    min-height: calc(100vh - 84px);
    background-color: rgba(240, 242, 245, 1);
  
    .module {
      background-color: #fff;
      padding: 16px;
      padding-right: 0;
      margin-bottom: 16px;
  
      .module-title {
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        font-weight: 700;
        color: #666;
      }
  
      .module-content {
        display: flex;
        flex-wrap: wrap;
  
        .module-content-item {
          margin: 16px 16px 0 0;
          width: 230px;
          height: 96px;
          background-color: rgba(240, 242, 245, 1);
          border-radius: 5px;
          padding: 16px;
          display: flex;
  
          &>div {
            &>span:first-child {
              font-size: 14px;
              color: #666;
            }
  
            &>span:last-child {
              display: inline-block;
              margin-top: 16px;
              font-size: 18px;
              color: #4E98FF;
            }
          }
        }
  
        .module-content-item2 {
          background-color: rgba(240, 242, 245, 1);
          width: 230px;
          height: 62px;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 16px 16px 0 0;
          cursor: pointer;
          color: #666;
        }
  
        .module-content-item2:hover {
          font-weight: 700;
        }
      }
    }
  
    .descriptions {
      margin:  16px 0;
      color: #666;
  
      .descriptions-row {
        min-width: 800px;
        display: flex;
  
        &:first-child {
          border-left: 1px solid #d4d4d4;
          border-top: 1px solid #d4d4d4;
        }
  
        &>div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
          flex: 1;
          border-bottom: 1px solid #d4d4d4;
          border-right: 1px solid #d4d4d4;
        }
  
        &>div:nth-child(2n-1) {
          background-color: rgba(240, 242, 245, 1);
          justify-content: flex-end;
          padding-right: 16px;
        }
      }
    }
  
    .module-descriptions {
      overflow-x: auto;
      padding-right: 16px;
    }
  }
  </style>
  